export default "__VITE_ASSET__b7014243__"